<template>
  <div class="payment-methods">
    <div class="methods">
      <DeployerAccountPaymentMethodsItem
        v-if="formattedPaymentData"
        :method="formattedPaymentData"
      />
      <!--      todo: activate when other payment methods will be available -->
      <!--      <DeployerAccountPaymentMethodsItem-->
      <!--        v-for="method in methods"-->
      <!--        :key="method.address"-->
      <!--        :method="method"-->
      <!--      />-->
    </div>
    <p class="notice-text" v-html="texts.notice" />

    <!--TODO: Kamil - add new payment method functionality -->
    <!--      todo: activate when other payment methods will be available -->
    <!--    <button-->
    <!--      type="button"-->
    <!--      class="btn text-link mt30"-->
    <!--      v-html="texts.add_new_method"-->
    <!--    />-->
  </div>
</template>

<script setup>
import { useAddressFormat } from '../../../composables/useAddressFormat.js'

const textsStore = useTextsStore()
const texts = computed(() => textsStore.account.billing.box_payment)

const props = defineProps({
  paymentData: Object
})

const formattedPaymentData = computed(() => {
  if (!props.paymentData) return null

  const { refId, paymentTokenSymbol, networkName } = props.paymentData
  return {
    address: useAddressFormat(refId),
    addressIcon: getNetworkIconUrl(networkName),
    currency: `${paymentTokenSymbol} Coin on ${networkName.charAt(0).toUpperCase() + networkName.slice(1).toLowerCase()}`,
    currencyIcon: getTokenIconUrl(paymentTokenSymbol),
    preferred: true
  }
})

//TODO: Kamil - get user's payment methods
const methods = computed(() => {
  return [
    {
      address: '0xEE38 ••• dCa9',
      addressIcon: 'https://content.diadata.org/images/assets-icons/1027.png',
      currency: 'USD Coin on Arbitrum',
      currencyIcon: 'https://content.diadata.org/images/assets-icons/1027.png',
      preferred: true
    },
    {
      address: '•••• •••• •••• 0109',
      addressIcon: 'https://content.diadata.org/images/assets-icons/1027.png',
      currency: 'US Dollars (Fiat)',
      currencyIcon: 'https://content.diadata.org/images/assets-icons/1027.png',
      preferred: false
    }
  ]
})
</script>

<style lang="scss" scoped>
.payment-methods {
  max-width: 555px;
}

.methods {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
